import { render, staticRenderFns } from "./message_set.vue?vue&type=template&id=4851083a&scoped=true&"
import script from "./message_set.vue?vue&type=script&lang=js&"
export * from "./message_set.vue?vue&type=script&lang=js&"
import style0 from "./message_set.vue?vue&type=style&index=0&id=4851083a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851083a",
  null
  
)

export default component.exports